import { render, staticRenderFns } from "./viewOrder.vue?vue&type=template&id=012cfa1e&scoped=true"
import script from "./viewOrder.vue?vue&type=script&lang=js"
export * from "./viewOrder.vue?vue&type=script&lang=js"
import style0 from "./viewOrder.vue?vue&type=style&index=0&id=012cfa1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012cfa1e",
  null
  
)

export default component.exports